import { render } from "./VerifyOpt.vue?vue&type=template&id=cc0116a4&scoped=true"
import script from "./VerifyOpt.vue?vue&type=script&lang=js"
export * from "./VerifyOpt.vue?vue&type=script&lang=js"

import "./VerifyOpt.vue?vue&type=style&index=0&id=cc0116a4&scoped=true&lang=css"
import "./VerifyOpt.vue?vue&type=style&index=1&id=cc0116a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0116a4"]])

export default __exports__